import { SupabaseClient } from "@supabase/supabase-js";
import { supabase_gps_tracker, supabase as supabaseClient } from "../supabaseClient";


export class SupabaseConnector {
  readonly client: SupabaseClient;
  readonly client_gps_tracker_client: SupabaseClient;

  constructor() {
    this.client = supabaseClient;
    this.client_gps_tracker_client = supabase_gps_tracker;
  }
}
